import {Route} from '@angular/router';
import {AuthGuard} from "../../shared/auth/auth.guard";
import { ContactManagementComponent } from './components/contact-management/contact-management.component';
import { NavigationManagementComponent } from './components/navigation-management/navigation-management.component';
import { ContactPersonDetailsComponent } from './components/contact-person-details/contact-person-details.component';

export const ContactsRoutes: Route[] = [
  {
    path: 'kontakte',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: NavigationManagementComponent,
      },
      {
        path: ':id',
        component: ContactPersonDetailsComponent
      }
    ]
  }
];